import { stat } from "fs";

const contractSearch = {
  state: {
    data: null
  },
  mutations: {
    SET_CONTRACTSEARCH: (state, contractSearch) => {
      state.data = contractSearch
    }
  }
}

export default contractSearch



// WEBPACK FOOTER //
// ./src/store/modules/contractSearch.js